import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipPortal = TooltipPrimitive.Portal

const TooltipContent = React.forwardRef(
  (
    {
      className = "",
      sideOffset = 4,
      collisionPadding = 12,
      avoidCollisions = true,
      style,
      ...props
    },
    ref,
  ) => (
    <TooltipPortal>
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        collisionPadding={collisionPadding}
        avoidCollisions={avoidCollisions}
        className={className}
        style={{
          zIndex: 9999,
          maxWidth: "min(20rem, calc(100vw - 2rem))",
          wordWrap: "break-word",
          borderRadius: "8px",
          border: "1px solid rgba(15, 23, 42, 0.08)",
          backgroundColor: "#fff",
          padding: "6px 12px",
          fontSize: "0.875rem",
          lineHeight: 1.4,
          color: "#111827",
          boxShadow: "0 8px 24px rgba(15, 23, 42, 0.18)",
          ...style,
        }}
        {...props}
      />
    </TooltipPortal>
  ),
)
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
  TooltipPortal,
}


